// @ts-strict-ignore
import { useMemo } from 'react';
import type { ThresholdResults } from 'flow/store/engine/types';

/**
 * Hook to derive source action threshold results based on provided parameters.
 * This logic determines which threshold results to use based on the following priority:
 * 1. If thresholdResults is provided, use it directly
 * 2. Otherwise, merge thresholdOutputResults for the given legacyActionId with portfolio evaluation flag
 */
export const useSourceActionThresholdResults = (
  thresholdResults: ThresholdResults | null,
  thresholdOutputResults: Record<string, any> | null,
  legacyActionId: string | null,
  isREPortfolioEvaluation: boolean,
) => useMemo(() => {
  if (thresholdResults) return thresholdResults;

  const results = {
    ...thresholdOutputResults?.[legacyActionId],
    is_portfolio_evaluation: isREPortfolioEvaluation,
  };
  return results || null;
}, [legacyActionId, thresholdOutputResults, thresholdResults, isREPortfolioEvaluation]);
